<template>
<div class="mt-3" v-if="pretsProgress && pretsProgress.montant_total > 0">
    <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-2 px-3">
        <h2 class="text-white text-sm font-semibold">Progression des prêts</h2>
    </div>
    <div class="px-2 py-3">
        <div class="flex justify-between items-center mb-1">
            <span class="text-sm text-gray-600 dark:text-gray-300">Progression globale</span>
            <span class="text-xs text-gray-500">{{ pretsProgress.progression.toFixed(0) }} %</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2.5">
            <div class="bg-indigo-600 h-2.5 rounded-full" :style="{width: pretsProgress.progression + '%'}"></div>
        </div>
        <div class="text-xs text-gray-500 mt-1">
            {{ format(pretsProgress.montant_rembourse) }} remboursés sur {{ format(pretsProgress.montant_total) }}
        </div>
        <div class="text-xs text-gray-400 mt-1" v-if="hasInterets">
            dont {{ format(pretsProgress.montant_interets) }} d'intérêts (montant emprunté : {{ format(pretsProgress.montant_emprunte) }})
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        pretsProgress: {
            type: Object,
            default: () => ({ montant_total: 0, montant_rembourse: 0, progression: 0, montant_emprunte: null, montant_interets: null })
        }
    },

    computed: {
        hasInterets() {
            return this.pretsProgress.montant_interets !== null && this.pretsProgress.montant_interets !== undefined;
        }
    },

    methods: {
        format(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }
    }
};
</script>
